import { PhoneType } from '../types';
import { useTranslation } from '../../hooks/useTranslation';

export const useGetPhoneTypeDisplayName = () => {
  const { t } = useTranslation();

  return function getPhoneTypeDisplayName(phoneType: PhoneType | string) {
    return t(`fieldFacets.phoneType.${phoneType}`, { defaultValue: phoneType });
  };
};
